import React from "react";

const SIZES = {
    sm: "h-4 w-4 border-2",
    md: "h-6 w-6 border-2",
    lg: "h-10 w-10 border-[3px]",
};

const Spinner = ({ size = "md", className = "", label = "Loading" }) => {
    const cls = SIZES[size] || SIZES.md;
    return (
        <span
            role="status"
            aria-live="polite"
            aria-label={label}
            className={`inline-block ${cls} ${className} animate-spin rounded-full border-brand-200 border-t-brand-600`}
        />
    );
};

export default Spinner;
